import { Box } from "@mui/material"
import { PageCard, PageCardContent } from "components/card"
import React from "react"

export const NewShopsKioskHPage = ({ Layout = Box }) => {
  return (
    <Layout aside={<></>}>
      <PageCard>
        <PageCardContent>New Shops Page</PageCardContent>
      </PageCard>
    </Layout>
  )
}
